var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Modal } from 'antd';
import { useActions } from '../../hooks/useActions';
import SubTitle from '../UI/SubTitles/SubTitle';
import { useDispatch, useSelector } from 'react-redux';
import { selectHands } from '../../Redux/selectors/selectors';
import styles from './ModalGPT.module.scss';
import '../../index.css';
import TypingLoader from '../UI/Loader/TypingLoader';
import { useEffect, useRef, useState } from 'react';
import { USE_DEV_API } from '../../config';
import SituationInfo from './SituationInfo';
import ChatHeader from './ChatHeader';
import HandHistory from './HandHistory';
import API from '../../axios';
import Feedback from './Feedback';
import { getAssistanceByData } from "../../Redux/_actions/asyncActions/Trainer/get_assistance_by_data";
import LoadingArea from "../../Loaders/LoadingArea";
var GPTFeedbackAnswer = 'Your feedback is appreciated! I will thoroughly analyze it and take it into consideration as I work to improve my explanations.';
var ModalGpt = function () {
    var dispatch = useDispatch();
    var _a = useSelector(selectHands), isLoadingHandData = _a.isLoadingHandData, isLoadingGPTResponse = _a.isLoadingGPTResponse, isOpenGPTModal = _a.isOpenGPTModal, handDataGPT = _a.handDataGPT, gptAnalysisData = _a.gptAnalysisData;
    var _b = useActions(), setGptAnalysisData = _b.setGptAnalysisData, setIsOpenAIAnalyzeModal = _b.setIsOpenAIAnalyzeModal, setHandData = _b.setHandData;
    // @ts-ignore
    var rate = gptAnalysisData === null || gptAnalysisData === void 0 ? void 0 : gptAnalysisData.rate;
    // @ts-ignore
    var feedback = gptAnalysisData === null || gptAnalysisData === void 0 ? void 0 : gptAnalysisData.feedback;
    // @ts-ignore
    var response_id = gptAnalysisData === null || gptAnalysisData === void 0 ? void 0 : gptAnalysisData.response_id;
    var _c = useState(null), like = _c[0], setLike = _c[1];
    var _d = useState(''), feedbackLocal = _d[0], setFeedbackLocal = _d[1];
    var _e = useState([]), paragraphs = _e[0], setParagraphs = _e[1];
    var chat = useRef();
    // @ts-ignore
    var trace = handDataGPT === null || handDataGPT === void 0 ? void 0 : handDataGPT.result.trace;
    // @ts-ignore
    var ante = handDataGPT === null || handDataGPT === void 0 ? void 0 : handDataGPT.anteNorm;
    // @ts-ignore
    var players = handDataGPT === null || handDataGPT === void 0 ? void 0 : handDataGPT.positions;
    // @ts-ignore
    var hands = handDataGPT === null || handDataGPT === void 0 ? void 0 : handDataGPT.hands;
    // @ts-ignore
    var spotId = handDataGPT === null || handDataGPT === void 0 ? void 0 : handDataGPT.spotId;
    // @ts-ignore
    var stacks = handDataGPT === null || handDataGPT === void 0 ? void 0 : handDataGPT.stacks;
    // @ts-ignore
    var isHero = handDataGPT === null || handDataGPT === void 0 ? void 0 : handDataGPT.isHero;
    useEffect(function () {
        if (!isLoadingGPTResponse) {
            setLike(rate);
            // @ts-ignore
            var formattedText = gptAnalysisData === null || gptAnalysisData === void 0 ? void 0 : gptAnalysisData.formatted;
            var paragraphs_1 = isOpenGPTModal && formattedText ? formattedText.split('<br/>') : ['Something went wrong'];
            var paragraphsData = paragraphs_1.map(function (item, index) { return ({
                isFirstAIMessage: index === 0,
                isUserMessage: false,
                message: item,
            }); });
            if (feedback) {
                paragraphsData.push({ isFirstAIMessage: false, isUserMessage: true, message: feedback });
                paragraphsData.push({ isFirstAIMessage: true, isUserMessage: false, message: GPTFeedbackAnswer });
            }
            setParagraphs(paragraphsData);
        }
    }, [isLoadingHandData, isLoadingGPTResponse]);
    var rateAnswer = function (rate) {
        var localRate = 0;
        if (rate === 'like') {
            if (like === 1) {
                localRate = null;
                setLike(null);
            }
            else {
                localRate = 1;
                setLike(1);
            }
        }
        if (rate === 'dislike') {
            if (like === 0) {
                localRate = null;
                setLike(null);
            }
            else {
                localRate = 0;
                setLike(0);
            }
        }
        var feedbackPayload = {
            feedback: null,
            rate: localRate,
            response_id: response_id,
        };
        API.post('send_gpt_feedback', feedbackPayload);
    };
    var getText = function (text) {
        if (!isLoadingGPTResponse && text) {
            return _jsx("div", { dangerouslySetInnerHTML: { __html: text } });
        }
        return null;
    };
    var sendFeedBack = function () {
        setParagraphs(function (prev) { return __spreadArray(__spreadArray([], prev, true), [
            { message: feedbackLocal, isFirstAIMessage: false, isUserMessage: true },
            { isFirstAIMessage: true, isUserMessage: false, message: GPTFeedbackAnswer },
        ], false); });
        setFeedbackLocal('');
        var feedbackPayload = {
            feedback: feedbackLocal,
            rate: like,
            response_id: response_id,
        };
        API.post('send_gpt_feedback', feedbackPayload);
    };
    var onCloseGPTModal = function () {
        setGptAnalysisData(null);
        setIsOpenAIAnalyzeModal(false);
        setLike(null);
        setFeedbackLocal('');
        setHandData(null);
        setParagraphs([{ isFirstAIMessage: true, isUserMessage: false, message: 'Something went wrong' }]);
    };
    useEffect(function () {
        // @ts-ignore
        dispatch(getAssistanceByData(spotId, players, isHero, stacks, hands, trace));
    }, [handDataGPT]);
    useEffect(function () {
        if (!isOpenGPTModal) {
            onCloseGPTModal();
        }
    }, [isOpenGPTModal, gptAnalysisData]);
    useEffect(function () {
        var _a, _b;
        if (chat.current) {
            (_a = chat.current) === null || _a === void 0 ? void 0 : _a.scrollTo({ top: (_b = chat.current) === null || _b === void 0 ? void 0 : _b.scrollHeight });
        }
    }, [paragraphs.length, chat]);
    // @ts-ignore
    return (_jsx(Modal, __assign({ centered: true, open: isOpenGPTModal, onCancel: onCloseGPTModal, footer: null, destroyOnClose: true, className: 'newModalStyles modalWithoutBodyPadding ', width: USE_DEV_API ? '1200px' : '1200px', title: _jsx(SubTitle, { text: 'GPT Coach', level: 7 }) }, { children: !isLoadingHandData ?
            _jsxs("main", __assign({ className: styles.mainWrapper }, { children: [_jsxs("div", { children: [_jsx(SituationInfo, { trace: trace, players: players, hands: hands, spotId: spotId, stacks: stacks, isHero: isHero }), _jsxs("div", __assign({ className: styles.GPTChatWrapper }, { children: [_jsx(ChatHeader, { setParagraphs: setParagraphs, handDataGPT: handDataGPT, setLike: setLike, isLoadingAI: isLoadingGPTResponse }), _jsx("div", __assign({ className: styles.paragraphsWrapper, ref: chat }, { children: paragraphs.map(function (paragraph, index) { return (_jsxs("div", __assign({ className: paragraph.isUserMessage ? styles.userFeedBackTextWrapper : styles.textWrapper }, { children: [_jsx("div", { className: paragraph.isFirstAIMessage ? styles.dialog : paragraph.isUserMessage ? styles.dialogUser : '' }), isLoadingGPTResponse && (_jsx("div", { children: _jsx(TypingLoader, {}) })), getText(paragraph.message)] }), index)); }) })), !isLoadingGPTResponse && (_jsx(Feedback, { rateAnswer: rateAnswer, isLoadingAI: isLoadingGPTResponse, feedback: feedbackLocal, setFeedback: setFeedbackLocal, sendFeedback: sendFeedBack, isHasFeedback: !!feedback, rate: like }))] }))] }), _jsx(HandHistory, { trace: trace, ante: ante, players: players, isHero: isHero })] }))
            :
                _jsxs("div", __assign({ style: { display: 'flex', alignItems: "center", height: '100%', flexDirection: 'column', justifyContent: 'center' } }, { children: [_jsx("div", __assign({ style: { height: 96 } }, { children: _jsx(LoadingArea, { isTableLoader: false }) })), _jsx("h2", { children: "Preloading hand data" })] })) })));
};
export default ModalGpt;
